import { render, staticRenderFns } from "./comparePrice.vue?vue&type=template&id=6f34755e&scoped=true&"
import script from "./comparePrice.vue?vue&type=script&lang=js&"
export * from "./comparePrice.vue?vue&type=script&lang=js&"
import style0 from "./comparePrice.vue?vue&type=style&index=0&id=6f34755e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34755e",
  null
  
)

export default component.exports